// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
import TimeLimitNotification from './TimeLimitNotification';

// SPDX-License-Identifier: EUPL-1.2
export { startTimeLimitNotification, stopTimeLimitNotification } from './TimeLimitNotification';

export default TimeLimitNotification;
